let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cF4mS")).then(() => parcelRequire('aeS3R'));